import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, CircularProgress, Grid, Paper, Tab } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { LoadingWidget } from '../../../../widgets';
import { allBloquesPedagogicosAction } from '../../bloques_pedagogicos/BloquesPedagogicosAction';
import { allFamiliaresAction } from '../../familiares/FamiliaresAction';
import { allHorariosAction } from '../../horarios/HorariosAction';
import { allPlanEvaluacionAction } from '../../plan_evaluacion/plan_evaluacion/PlanEvaluacionAction';
import {
  asistenciasDiariasEstudianteAction,
  notasEvaluativasEstudianteAction,
} from '../EstudiantesAction';
import AsistenciasDiariasEstudianteComponent from './components/AsistenciasDiariasEstudiante';
import FamiliaresEstudiantesComponent from './components/FamiliaresEstudiantes';
import InformacionEstudianteComponent from './components/InformacionEstudiante';
import NotasEvaluativasEstudianteComponent from './components/NotasEvaluativasEstudiante';
import ActividadesGraficoLineComponent from './graficos/ActividadesGraficoLine';

const PanelEstudiantesView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);

  const activo = estudiantesStore.activo;

  const [loading, setLoading] = React.useState(true);
  const [tab, setValue] = React.useState(1);

  const handleTabs = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      await allBloquesPedagogicosAction(dispatch, {
        idEntidad: entidadesStore.activo.id,
      });

      await allPlanEvaluacionAction(dispatch, {
        idEntidad: entidadesStore.activo.id,
        idPeriodoAcademico: entidadesStore.ajustes.periodoAcademico.id,
        idSeccion: activo.matricula.secciones[0].seccion.id,
      });

      await notasEvaluativasEstudianteAction(dispatch, activo.id, {
        idPeriodoAcademico: entidadesStore.ajustes.periodoAcademico.id,
      });

      await allHorariosAction(
        { dispatch },
        {
          idEntidad: entidadesStore.activo.id,
          idPeriodoAcademico: entidadesStore.ajustes.periodoAcademico.id,
          idSeccion: activo.matricula.secciones[0].seccion.id,
        },
      );

      await asistenciasDiariasEstudianteAction(dispatch, activo.id, {
        idPeriodoAcademico: entidadesStore.ajustes.periodoAcademico.id,
      });

      await allFamiliaresAction(dispatch, {
        idEntidad: entidadesStore.activo.id,
        idEstudiante: activo.usuario.id,
      });

      setLoading(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tabs = [
    {
      id: 1,
      title: 'Gráficas',
      component: <ActividadesGraficoLineComponent />,
    },
    {
      id: 2,
      title: 'Notas',
      component: <NotasEvaluativasEstudianteComponent />,
    },
    {
      id: 3,
      title: 'Asistencias',
      component: <AsistenciasDiariasEstudianteComponent />,
    },
    {
      id: 4,
      title: 'Familiares',
      component: <FamiliaresEstudiantesComponent />,
    },
    // {
    //   id: 5,
    //   title: 'Horario',
    //   component: <div>Horario</div>,
    // },
  ];

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingWidget isLoading={estudiantesStore.loadingAll} />
      </Grid>
      <Grid item md={4}>
        <InformacionEstudianteComponent />
      </Grid>
      <Grid item md={8}>
        {loading ? (
          <center>
            <CircularProgress size="3rem" />
          </center>
        ) : (
          <Paper elevation={4}>
            <TabContext value={tab}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList
                  onChange={handleTabs}
                  aria-label="panel estudiante tabs"
                >
                  {tabs.map((t) => (
                    <Tab key={t.id} label={t.title} value={t.id} />
                  ))}
                </TabList>
              </Box>
              {tabs.map((t) => (
                <TabPanel key={t.id} value={t.id} sx={{ p: 0 }}>
                  {t.component}
                </TabPanel>
              ))}
            </TabContext>
          </Paper>
        )}
      </Grid>

      {/* <ModalComponent
        id="modalFormEstudiantes"
        title={`${
          activo
            ? `Editar ${activo.nombre}-${activo.nivelAcademico.nivelAcademico.nombre}`
            : "Nueva sección"
        }`}
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormEstudiantes
          activo={activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        /> 
      </ModalComponent> */}
    </Grid>
  );
};

export default PanelEstudiantesView;
